export default __webpack_public_path__ + "static/media/TON_symbol.14d59417.svg";